<!-- Bridges the gap between the inline shell in index.html and the first route.
     Styled by the global .mo-boot rules in index.html — see `booting`. -->
@if (booting()) {
  <div class="mo-boot" role="progressbar" aria-label="Loading mogenius">
    <div class="mo-boot__ring"></div>
  </div>
}
<router-outlet></router-outlet>
<p-confirmdialog></p-confirmdialog>
<mo-notification-banner-list></mo-notification-banner-list>
<mo-command-palette *moOnly></mo-command-palette>
